import { render, staticRenderFns } from "./order-submit.vue?vue&type=template&id=3df8f83e&scoped=true"
import script from "./order-submit.vue?vue&type=script&lang=js"
export * from "./order-submit.vue?vue&type=script&lang=js"
import style0 from "./order-submit.vue?vue&type=style&index=0&id=3df8f83e&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/order-submit.less?vue&type=style&index=1&id=3df8f83e&prod&scoped=true&lang=less&external"
import style2 from "./order-submit.vue?vue&type=style&index=2&id=3df8f83e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8f83e",
  null
  
)

export default component.exports